module.exports = __webpack_public_path__ + "static/parade-2019-house12-62eca720b850975d4af9af4b23bcdc41.jpg";